/**
 * "I'VE PAID" EXISTS ONLY WHERE THE CLUB TAKES PAYMENT THROUGH ITS OWN LINK (owner,
 * 2026-09-26; /ux mark-paid-fixes A3). The server answers it once, as `takesLinkPayments` on
 * the club read (backend `ae9ec4f4`, `clubPayments/linkLane.mjs`): the club's mode is `link`
 * (or no mode and a link, the legacy reading) AND the link is a valid https URL. Nothing here
 * re-derives it from the URL — a club that switched back to Pay at the club keeps its old link.
 *
 * REMEMBERED BY EVERY READ THAT CARRIES IT, the way `publicScheduleVisibility.ts` remembers
 * its flag: surfaces that hold only an `orgId` (a share on My bookings, the desk's claim rows)
 * read it back with no request of their own. FAIL CLOSED: a club this tab has not read, or a
 * read that did not carry the field, is a club without the lane — the player is sent to the
 * desk, which is always true, and never shown a claim the server would refuse.
 */

const known = new Map<string, boolean>()

export function rememberLinkLane(club: { orgId?: string; takesLinkPayments?: unknown } | null | undefined): void {
  const orgId = String(club?.orgId || '').trim()
  if (!orgId || typeof club?.takesLinkPayments !== 'boolean') return
  known.set(orgId, club.takesLinkPayments)
}

export function clubTakesLinkPayments(orgId: string | null | undefined): boolean {
  return known.get(String(orgId || '').trim()) === true
}

/** The club's link, only while it takes payment through it — the one door every link-lane
 *  surface (the pay block, the claim) is gated through. */
export function linkLaneUrl(
  club: { takesLinkPayments?: boolean; paymentLinkUrl?: string | null } | null | undefined,
): string | null {
  return club?.takesLinkPayments === true ? club.paymentLinkUrl || null : null
}

/** A claim refused because the club has no link lane (`409 claim_needs_payment_link`) —
 *  reached only by a stale page or the API, since the buttons are gone. Read by CODE. */
export const CLAIM_NEEDS_PAYMENT_LINK = 'claim_needs_payment_link'

export function claimNeedsLinkSentence(clubName: string | null | undefined): string {
  return `${String(clubName || '').trim() || 'This club'} doesn't take payments online. Pay at the desk — the club will mark it paid.`
}
